import axios from "axios"
import VueAxios from "vue-axios"
import config from "../base/config";

let baseurl = "";

if(process.env.NODE_ENV === 'production'){
	 baseurl = config.BASE_URL;
}else{
	 baseurl = "/api";
}

export const request = (options)=>{
	return new Promise((resolve,reject)=>{
      let data = options.data || "";
      if(options.method=="post"){
          axios.post(baseurl+"/"+options.url,data,{headers:options.headers}).then((res)=>{
            resolve(res);
          }).catch((err)=>{
            reject(err);
          });
      }else{
        axios.get(baseurl+"/"+options.url,{params:data}).then((res)=>{
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      }
	})
}



//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 